/* tslint:disable */
/* eslint-disable */
/* @relayHash e32c6f5baf11cf1b2a421b4be6882145 */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ProfileQueryVariables = {
    storyID?: string | null;
    storyURL?: string | null;
};
export type ProfileQueryResponse = {
    readonly story: {
        readonly " $fragmentRefs": FragmentRefs<"ProfileContainer_story">;
    } | null;
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"ProfileContainer_viewer">;
    } | null;
    readonly settings: {
        readonly " $fragmentRefs": FragmentRefs<"ProfileContainer_settings">;
    };
};
export type ProfileQuery = {
    readonly response: ProfileQueryResponse;
    readonly variables: ProfileQueryVariables;
};



/*
query ProfileQuery(
  $storyID: ID
  $storyURL: String
) {
  story: stream(id: $storyID, url: $storyURL) {
    ...ProfileContainer_story
    id
  }
  viewer {
    ...ProfileContainer_viewer
    id
  }
  settings {
    ...ProfileContainer_settings
    id
  }
}

fragment AccountSettingsContainer_settings on Settings {
  accountFeatures {
    deleteAccount
  }
  ...ChangePasswordContainer_settings
  ...DeleteAccountContainer_settings
  ...ChangeEmailContainer_settings
  ...ChangeUsernameContainer_settings
}

fragment AccountSettingsContainer_viewer on User {
  ...DeleteAccountContainer_viewer
  ...ChangeUsernameContainer_viewer
  ...ChangeEmailContainer_viewer
}

fragment BioContainer_settings on Settings {
  memberBios
}

fragment BioContainer_viewer on User {
  bio
}

fragment ChangeEmailContainer_settings on Settings {
  auth {
    integrations {
      local {
        enabled
        targetFilter {
          stream
        }
      }
      google {
        enabled
        targetFilter {
          stream
        }
      }
      oidc {
        enabled
        targetFilter {
          stream
        }
      }
      sso {
        enabled
        targetFilter {
          stream
        }
      }
      facebook {
        enabled
        targetFilter {
          stream
        }
      }
    }
  }
}

fragment ChangeEmailContainer_viewer on User {
  email
  emailVerified
  profiles {
    __typename
  }
}

fragment ChangePasswordContainer_settings on Settings {
  auth {
    integrations {
      local {
        enabled
        targetFilter {
          stream
        }
      }
    }
  }
}

fragment ChangeUsernameContainer_settings on Settings {
  accountFeatures {
    changeUsername
  }
  auth {
    integrations {
      local {
        enabled
        targetFilter {
          stream
        }
      }
      google {
        enabled
        targetFilter {
          stream
        }
      }
      oidc {
        enabled
        targetFilter {
          stream
        }
      }
      sso {
        enabled
        targetFilter {
          stream
        }
      }
      facebook {
        enabled
        targetFilter {
          stream
        }
      }
    }
  }
}

fragment ChangeUsernameContainer_viewer on User {
  username
  profiles {
    __typename
  }
  status {
    username {
      history {
        username
        createdAt
      }
    }
  }
}

fragment CommentHistoryContainer_settings on Settings {
  ...HistoryCommentContainer_settings
}

fragment CommentHistoryContainer_story on Story {
  ...HistoryCommentContainer_story
}

fragment CommentHistoryContainer_viewer on User {
  comments(first: 5) {
    edges {
      node {
        id
        ...HistoryCommentContainer_comment
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment DeleteAccountContainer_settings on Settings {
  organization {
    contactEmail
  }
}

fragment DeleteAccountContainer_viewer on User {
  id
  scheduledDeletionDate
}

fragment DeletionRequestCalloutContainer_viewer on User {
  scheduledDeletionDate
}

fragment DownloadCommentsContainer_viewer on User {
  id
  lastDownloadedAt
}

fragment EmailNotificationSettingsContainer_viewer on User {
  notifications {
    onReply
    onFeatured
    onStaffReplies
    onModeration
    digestFrequency
  }
}

fragment HistoryCommentContainer_comment on Comment {
  id
  body
  createdAt
  ...MediaSectionContainer_comment
  parent {
    id
    author {
      username
      id
    }
  }
  rating
  story {
    id
    url
    metadata {
      title
    }
    settings {
      mode
    }
  }
  ...HistoryCommentFooterContainer_comment
}

fragment HistoryCommentContainer_settings on Settings {
  ...HistoryCommentFooterContainer_settings
  ...MediaSectionContainer_settings
}

fragment HistoryCommentContainer_story on Story {
  id
}

fragment HistoryCommentFooterContainer_comment on Comment {
  id
  reactions(first: 20) {
    edges {
      node {
        id
        reacter {
          username
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  story {
    id
    url
    metadata {
      title
    }
  }
  replyCount
  canReply
  actionCounts {
    reaction {
      total
    }
  }
}

fragment HistoryCommentFooterContainer_settings on Settings {
  reaction {
    label
    icon
  }
}

fragment IgnoreUserSettingsContainer_viewer on User {
  ignoredUsers {
    id
    username
  }
}

fragment InPageNotificationSettingsContainer_viewer on User {
  inPageNotifications {
    enabled
    onReply {
      enabled
      showReplies
    }
    onFeatured
    onModeration
  }
}

fragment MediaSectionContainer_comment on Comment {
  id
  site {
    id
  }
  revision {
    media {
      __typename
      ... on GiphyMedia {
        url
        title
        width
        height
        still
        video
      }
      ... on TenorMedia {
        url
      }
      ... on TwitterMedia {
        url
        width
      }
      ... on BlueskyMedia {
        url
        width
      }
      ... on YouTubeMedia {
        url
        width
        height
      }
      ... on ExternalMedia {
        url
      }
    }
    id
  }
}

fragment MediaSectionContainer_settings on Settings {
  media {
    twitter {
      enabled
    }
    bluesky {
      enabled
    }
    youtube {
      enabled
    }
    gifs {
      enabled
      provider
    }
    external {
      enabled
    }
  }
}

fragment MediaSettingsContainer_settings on Settings {
  media {
    gifs {
      enabled
      provider
    }
    twitter {
      enabled
    }
    youtube {
      enabled
    }
    external {
      enabled
    }
  }
}

fragment MediaSettingsContainer_viewer on User {
  id
  mediaSettings {
    unfurlEmbeds
  }
}

fragment MyCommentsContainer_settings on Settings {
  accountFeatures {
    downloadComments
  }
  ...CommentHistoryContainer_settings
}

fragment MyCommentsContainer_story on Story {
  ...CommentHistoryContainer_story
}

fragment MyCommentsContainer_viewer on User {
  ...CommentHistoryContainer_viewer
  ...DownloadCommentsContainer_viewer
}

fragment PreferencesContainer_settings on Settings {
  inPageNotifications {
    enabled
  }
  externalNotifications {
    active
  }
  ...MediaSettingsContainer_settings
  ...BioContainer_settings
}

fragment PreferencesContainer_viewer on User {
  ...EmailNotificationSettingsContainer_viewer
  ...InPageNotificationSettingsContainer_viewer
  ...IgnoreUserSettingsContainer_viewer
  ...MediaSettingsContainer_viewer
  ...BioContainer_viewer
}

fragment ProfileContainer_settings on Settings {
  ...UserBoxContainer_settings
  ...AccountSettingsContainer_settings
  ...MyCommentsContainer_settings
  ...PreferencesContainer_settings
}

fragment ProfileContainer_story on Story {
  ...MyCommentsContainer_story
}

fragment ProfileContainer_viewer on User {
  ...UserBoxContainer_viewer
  ...AccountSettingsContainer_viewer
  ...MyCommentsContainer_viewer
  ...DeletionRequestCalloutContainer_viewer
  ...PreferencesContainer_viewer
  profiles {
    __typename
  }
  ssoURL
}

fragment UserBoxContainer_settings on Settings {
  auth {
    integrations {
      local {
        enabled
        allowRegistration
        targetFilter {
          stream
        }
      }
      oidc {
        enabled
        allowRegistration
        targetFilter {
          stream
        }
      }
      google {
        enabled
        allowRegistration
        targetFilter {
          stream
        }
      }
      facebook {
        enabled
        allowRegistration
        targetFilter {
          stream
        }
      }
    }
  }
}

fragment UserBoxContainer_viewer on User {
  username
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "storyID"
        } as any),
        ({
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "storyURL"
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "id",
            "variableName": "storyID"
        } as any),
        ({
            "kind": "Variable",
            "name": "url",
            "variableName": "storyURL"
        } as any)
    ], v2 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any), v3 = [
        (v2 /*: any*/)
    ], v4 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "username",
        "storageKey": null
    } as any), v5 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any), v6 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
    } as any), v7 = [
        ({
            "kind": "Literal",
            "name": "first",
            "value": 5
        } as any)
    ], v8 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
    } as any), v9 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
    } as any), v10 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "width",
        "storageKey": null
    } as any), v11 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "height",
        "storageKey": null
    } as any), v12 = [
        (v8 /*: any*/)
    ], v13 = [
        (v8 /*: any*/),
        (v10 /*: any*/)
    ], v14 = [
        ({
            "kind": "Literal",
            "name": "first",
            "value": 20
        } as any)
    ], v15 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
    } as any), v16 = ({
        "alias": null,
        "args": null,
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v17 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "onFeatured",
        "storageKey": null
    } as any), v18 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "onModeration",
        "storageKey": null
    } as any), v19 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "enabled",
        "storageKey": null
    } as any), v20 = ({
        "alias": null,
        "args": null,
        "concreteType": "AuthenticationTargetFilter",
        "kind": "LinkedField",
        "name": "targetFilter",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "stream",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v21 = [
        (v19 /*: any*/),
        ({
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "allowRegistration",
            "storageKey": null
        } as any),
        (v20 /*: any*/)
    ], v22 = [
        (v19 /*: any*/)
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "ProfileQuery",
            "selections": [
                {
                    "alias": "story",
                    "args": (v1 /*: any*/),
                    "concreteType": "Story",
                    "kind": "LinkedField",
                    "name": "stream",
                    "plural": false,
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "ProfileContainer_story"
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "ProfileContainer_viewer"
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Settings",
                    "kind": "LinkedField",
                    "name": "settings",
                    "plural": false,
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "ProfileContainer_settings"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "ProfileQuery",
            "selections": [
                {
                    "alias": "story",
                    "args": (v1 /*: any*/),
                    "concreteType": "Story",
                    "kind": "LinkedField",
                    "name": "stream",
                    "plural": false,
                    "selections": (v3 /*: any*/),
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        (v4 /*: any*/),
                        (v2 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "scheduledDeletionDate",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "profiles",
                            "plural": true,
                            "selections": [
                                (v5 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserStatus",
                            "kind": "LinkedField",
                            "name": "status",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "UsernameStatus",
                                    "kind": "LinkedField",
                                    "name": "username",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "UsernameHistory",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": true,
                                            "selections": [
                                                (v4 /*: any*/),
                                                (v6 /*: any*/)
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "email",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "emailVerified",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": (v7 /*: any*/),
                            "concreteType": "CommentsConnection",
                            "kind": "LinkedField",
                            "name": "comments",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CommentEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Comment",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                (v2 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "body",
                                                    "storageKey": null
                                                },
                                                (v6 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Site",
                                                    "kind": "LinkedField",
                                                    "name": "site",
                                                    "plural": false,
                                                    "selections": (v3 /*: any*/),
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "CommentRevision",
                                                    "kind": "LinkedField",
                                                    "name": "revision",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "media",
                                                            "plural": false,
                                                            "selections": [
                                                                (v5 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        (v8 /*: any*/),
                                                                        (v9 /*: any*/),
                                                                        (v10 /*: any*/),
                                                                        (v11 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "still",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "video",
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "GiphyMedia",
                                                                    "abstractKey": null
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": (v12 /*: any*/),
                                                                    "type": "TenorMedia",
                                                                    "abstractKey": null
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": (v13 /*: any*/),
                                                                    "type": "TwitterMedia",
                                                                    "abstractKey": null
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": (v13 /*: any*/),
                                                                    "type": "BlueskyMedia",
                                                                    "abstractKey": null
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        (v8 /*: any*/),
                                                                        (v10 /*: any*/),
                                                                        (v11 /*: any*/)
                                                                    ],
                                                                    "type": "YouTubeMedia",
                                                                    "abstractKey": null
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": (v12 /*: any*/),
                                                                    "type": "ExternalMedia",
                                                                    "abstractKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v2 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Comment",
                                                    "kind": "LinkedField",
                                                    "name": "parent",
                                                    "plural": false,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "User",
                                                            "kind": "LinkedField",
                                                            "name": "author",
                                                            "plural": false,
                                                            "selections": [
                                                                (v4 /*: any*/),
                                                                (v2 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "rating",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Story",
                                                    "kind": "LinkedField",
                                                    "name": "story",
                                                    "plural": false,
                                                    "selections": [
                                                        (v2 /*: any*/),
                                                        (v8 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "StoryMetadata",
                                                            "kind": "LinkedField",
                                                            "name": "metadata",
                                                            "plural": false,
                                                            "selections": [
                                                                (v9 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "StorySettings",
                                                            "kind": "LinkedField",
                                                            "name": "settings",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "mode",
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": (v14 /*: any*/),
                                                    "concreteType": "ReactionsConnection",
                                                    "kind": "LinkedField",
                                                    "name": "reactions",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "ReactionEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "Reaction",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v2 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "Reacter",
                                                                            "kind": "LinkedField",
                                                                            "name": "reacter",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v4 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        (v5 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v15 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        (v16 /*: any*/)
                                                    ],
                                                    "storageKey": "reactions(first:20)"
                                                },
                                                {
                                                    "alias": null,
                                                    "args": (v14 /*: any*/),
                                                    "filters": null,
                                                    "handle": "connection",
                                                    "key": "HistoryCommentFooter_reactions",
                                                    "kind": "LinkedHandle",
                                                    "name": "reactions"
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "replyCount",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "canReply",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ActionCounts",
                                                    "kind": "LinkedField",
                                                    "name": "actionCounts",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "ReactionActionCounts",
                                                            "kind": "LinkedField",
                                                            "name": "reaction",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "total",
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                },
                                                (v5 /*: any*/)
                                            ],
                                            "storageKey": null
                                        },
                                        (v15 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                (v16 /*: any*/)
                            ],
                            "storageKey": "comments(first:5)"
                        },
                        {
                            "alias": null,
                            "args": (v7 /*: any*/),
                            "filters": null,
                            "handle": "connection",
                            "key": "CommentHistory_comments",
                            "kind": "LinkedHandle",
                            "name": "comments"
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "lastDownloadedAt",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserEmailNotificationSettings",
                            "kind": "LinkedField",
                            "name": "notifications",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "onReply",
                                    "storageKey": null
                                },
                                (v17 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "onStaffReplies",
                                    "storageKey": null
                                },
                                (v18 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "digestFrequency",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserInPageNotificationSettings",
                            "kind": "LinkedField",
                            "name": "inPageNotifications",
                            "plural": false,
                            "selections": [
                                (v19 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "OnReplySettings",
                                    "kind": "LinkedField",
                                    "name": "onReply",
                                    "plural": false,
                                    "selections": [
                                        (v19 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "showReplies",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                (v17 /*: any*/),
                                (v18 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "ignoredUsers",
                            "plural": true,
                            "selections": [
                                (v2 /*: any*/),
                                (v4 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserMediaSettings",
                            "kind": "LinkedField",
                            "name": "mediaSettings",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "unfurlEmbeds",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "bio",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "ssoURL",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Settings",
                    "kind": "LinkedField",
                    "name": "settings",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Auth",
                            "kind": "LinkedField",
                            "name": "auth",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AuthIntegrations",
                                    "kind": "LinkedField",
                                    "name": "integrations",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "LocalAuthIntegration",
                                            "kind": "LinkedField",
                                            "name": "local",
                                            "plural": false,
                                            "selections": (v21 /*: any*/),
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "OIDCAuthIntegration",
                                            "kind": "LinkedField",
                                            "name": "oidc",
                                            "plural": false,
                                            "selections": (v21 /*: any*/),
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "GoogleAuthIntegration",
                                            "kind": "LinkedField",
                                            "name": "google",
                                            "plural": false,
                                            "selections": (v21 /*: any*/),
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "FacebookAuthIntegration",
                                            "kind": "LinkedField",
                                            "name": "facebook",
                                            "plural": false,
                                            "selections": (v21 /*: any*/),
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "SSOAuthIntegration",
                                            "kind": "LinkedField",
                                            "name": "sso",
                                            "plural": false,
                                            "selections": [
                                                (v19 /*: any*/),
                                                (v20 /*: any*/)
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "CommenterAccountFeatures",
                            "kind": "LinkedField",
                            "name": "accountFeatures",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "deleteAccount",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "changeUsername",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "downloadComments",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Organization",
                            "kind": "LinkedField",
                            "name": "organization",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "contactEmail",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "ReactionConfiguration",
                            "kind": "LinkedField",
                            "name": "reaction",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "label",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "icon",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "MediaConfiguration",
                            "kind": "LinkedField",
                            "name": "media",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TwitterMediaConfiguration",
                                    "kind": "LinkedField",
                                    "name": "twitter",
                                    "plural": false,
                                    "selections": (v22 /*: any*/),
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "BlueskyMediaConfiguration",
                                    "kind": "LinkedField",
                                    "name": "bluesky",
                                    "plural": false,
                                    "selections": (v22 /*: any*/),
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "YouTubeMediaConfiguration",
                                    "kind": "LinkedField",
                                    "name": "youtube",
                                    "plural": false,
                                    "selections": (v22 /*: any*/),
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "GifMediaConfiguration",
                                    "kind": "LinkedField",
                                    "name": "gifs",
                                    "plural": false,
                                    "selections": [
                                        (v19 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "provider",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ExternalMediaConfiguration",
                                    "kind": "LinkedField",
                                    "name": "external",
                                    "plural": false,
                                    "selections": (v22 /*: any*/),
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "InPageNotificationsConfiguration",
                            "kind": "LinkedField",
                            "name": "inPageNotifications",
                            "plural": false,
                            "selections": (v22 /*: any*/),
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "ExternalNotificationsConfiguration",
                            "kind": "LinkedField",
                            "name": "externalNotifications",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "active",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "memberBios",
                            "storageKey": null
                        },
                        (v2 /*: any*/)
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "id": "e32c6f5baf11cf1b2a421b4be6882145",
            "metadata": {},
            "name": "ProfileQuery",
            "operationKind": "query",
            "text": null
        }
    } as any;
})();
(node as any).hash = '3c767da5a00c81a1a88d1a55cfdc99f3';
export default node;
